import { Component } from '@angular/core';

import { CreateOrganizationDetailsComponent } from '@components/create-organization-details/create-organization-details.component';
import { ContactDetailsComponent } from '@components/contact-details/contact-details.component';
import { TaxIdentificationNumberDetailsComponent } from '@components/tax-identification-number-details/tax-identification-number-details.component';
@Component({
  selector: 'app-organization',
  imports: [
    CreateOrganizationDetailsComponent,
    ContactDetailsComponent,
    TaxIdentificationNumberDetailsComponent
  ],
  templateUrl: './organization.component.html',
  styleUrl: './organization.component.css'
})
export class OrganizationComponent {

}
